import { render, staticRenderFns } from "./withdraw.vue?vue&type=template&id=530642bf&scoped=true&"
import script from "./withdraw.vue?vue&type=script&lang=js&"
export * from "./withdraw.vue?vue&type=script&lang=js&"
import style0 from "./withdraw.vue?vue&type=style&index=0&id=530642bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530642bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530642bf')) {
      api.createRecord('530642bf', component.options)
    } else {
      api.reload('530642bf', component.options)
    }
    module.hot.accept("./withdraw.vue?vue&type=template&id=530642bf&scoped=true&", function () {
      api.rerender('530642bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/order/components/withdraw.vue"
export default component.exports